/**
 * VTE Risk Calculator Backend API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface LoginResponse { 
    access_token?: string;
    expires_in?: number;
    token_type?: string;
    refresh_token?: string;
}